import { getPageMeta, mergeMeta } from "~/utils";

import { LoaderFunctionArgs } from "@vercel/remix";
import { MetaFunction } from "@remix-run/react";
import { RootLoader } from "~/root";

export const meta = mergeMeta<typeof loader, { root: RootLoader }>(
  ({ data, location }) => {
    return [
      ...getPageMeta({
        title: "Om oss | NordicPosterStore",
        description: `Upptäck konst för varje vägg på NordicPosterStore. Utforska vilka vi är, vad vi gör, och varför vi brinner för väggprints.`,
        ogUrl: "https://www.nordicposterstore.com/se/about-us",
      }),
      { robots: "index,follow" },
    ];
  }
);

export const loader = async ({ request, params }: LoaderFunctionArgs) => {
  return { data: "kommer snart" };
};

const AboutUs = () => {
  return (
    <section className=" py-4 lg:w-[50%] md:my-0 mx-4 lg:mx-auto min-h-[80vh] pb-20 text-sm">
      <div className="mb-9">
        <div className="mb-6">
          <h1 className="mb-6 text-3xl font-masonExtendedBold">
            Om NordicPosterStore
          </h1>
        </div>
      </div>

      <div className="grid gap-6 mt-8 ">
        <p>
          Välkommen till NordicPosterStore, din främsta online-destination för
          kuraterade posterkollektioner som ger stil och personlighet till varje
          hem och vägg. Grundat i <b>Göteborg</b>, erbjuder vi ett brett utbud
          av fängslande posters designade för att förvandla alla utrymmen till
          en oas av värme och inspiration.
        </p>
        <p>
          På NordicPosterStore är vi stolta över vårt noggrant utvalda
          sortiment, som innehåller en variation av stilar, teman och
          konstnärliga uttryck för att passa alla smaker och
          inredningspreferenser. Från djärva och livliga tryck till
          minimalistiska designer och allt däremellan, är vår kollektion
          noggrant skapad för att tillgodose våra kunders olika smaker.
        </p>
        <p>
          Vi är mer än bara en annan postersbutik; vi är ett nav för kreativitet
          och gemenskap. Vi värdesätter våra kunders uppskattning för modern
          konst och strävar efter att ge dem de finaste urvalen som speglar
          deras samtida smaker och preferenser. Vår användarvänliga webbplats
          erbjuder en uppslukande webbläsarupplevelse, vilket gör att du kan
          utforska våra kuraterade kollektioner från var som helst. Oavsett om
          du söker inspiration för ett specifikt rum eller bara vill lägga till
          en touch av personlighet till ditt utrymme, erbjuder vår omfattande
          kollektion av posters något för alla.
        </p>

        <p>
          Med ett engagemang för kvalitet, kreativitet och kundnöjdhet, strävar
          NordicPosterStore efter att erbjuda en exceptionell shoppingupplevelse
          från början till slut. Följ med oss på vår mission att förvandla hus
          till varma och inbjudande hem, en poster i taget.
        </p>

        <div className="font-masonExtendedBold text-lg break-words whitespace-pre-line">
          <p>Välkommen till NordicPosterStore - där konst möter heminredning</p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
